import { useDocsDataModelStore } from '@/models/docs-data/docsData';
import { Modal } from 'aui';
import { MCPModalContent } from './components/MCPModalContent';
import styles from './index.module.css';
type TProps = {
  visible?: boolean;
  onCancel: () => void;
};

export function VibeCodingViaMCPModal(props: TProps) {
  const { visible, onCancel } = props;
  const onlineId = useDocsDataModelStore((x) => x.docsIdTypeData.onlineId);
  const title = useDocsDataModelStore((x) => x.docsBaseConfig.title);

  return (
    <Modal
      open={visible}
      onCancel={onCancel}
      destroyOnClose
      size={720}
      footer={null}
      className={styles.useMcpModal}
    >
      <MCPModalContent projectName={title} docSiteId={onlineId} />
    </Modal>
  );
}
